import { render, staticRenderFns } from "./SmallRightBigLeft.vue.js?vue&type=template&id=9cb7f376!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SmallRightBigLeft.vue?vue&type=template&id=9cb7f376"
import script from "./SmallRightBigLeft.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SmallRightBigLeft.vue?vue&type=script&lang=js"
export * from "./SmallRightBigLeft.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SmallRightBigLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports